<agr-page-detail
  [pageTitle]="title"
  [hasPrimaryAction]="true"
  primaryActionIcon="print"
  primaryActionText="Print"
  (primaryAction)="print()"
  (backAction)="back()"
>
  <agr-print-page
    data-test="flock-report__page"
    orientation="landscape"
    [customizedLogoSrc]="customizedLogoSrc"
    [showAgrifirmLogo]="showAgrifirmLogo"
  >
    <div class="wrapper--spacing-horizontal wrapper--spacing-vertical">
      <span class="text--bold">{{ 'report.customer-details.header' | translate }}</span>
      <ul class="info-header">
        <li>
          <label class="text-bold"
            >{{ 'report.customer-details.customer-number' | translate }}:
          </label>
          <label class="wide-label">{{ customer?.externalId }}</label>
        </li>
        <li>
          <label class="text-bold">{{ 'report.customer-details.name' | translate }}:</label>
          <label class="wide-label">{{ customer?.name }}</label>
        </li>
        <li>
          <label class="text-bold">{{ 'report.customer-details.address' | translate }}:</label>
          <label class="wide-label"
            >{{ customer?.street }} {{ customer?.houseNumber }} {{ customer?.houseNumberAddition }}
            {{ customer?.postalCode }} {{ customer?.city }}
          </label>
        </li>
        <li>
          <label class="text-bold"
            >{{ 'report.customer-details.location-name' | translate }}:</label
          >
          <label class="wide-label">{{ location?.name }}</label>
        </li>
        <li>
          <label class="text-bold">
            {{ 'report.customer-details.location-address' | translate }}:</label
          >
          <label class="wide-label"
            >{{ location?.street }} {{ location?.houseNumber }} {{ location?.houseNumberAddition }}
            {{ location?.postalCode }} {{ location?.city }}
          </label>
        </li>
      </ul>
    </div>

    <div class="wrapper--spacing-horizontal wrapper--spacing-vertical">
      <span class="text--bold">{{ 'report.flock-details.header' | translate }}</span>
      <table>
        <tr>
          <th>{{ 'report.flock-details.flock' | translate }}</th>
          <th>{{ 'report.flock-details.breed' | translate }}</th>
          <th>{{ 'report.flock-details.amount-of-hens' | translate }}</th>
          <th>{{ 'report.flock-details.marketing-standard' | translate }}</th>
          <th>{{ 'report.flock-details.arrival-date' | translate }}</th>
          <th>{{ 'report.flock-details.departure-date' | translate }}</th>
          <th>{{ 'report.flock-details.age-start-production-period' | translate }}</th>
          <th>{{ 'report.flock-details.barn' | translate }}</th>
        </tr>
        <tr>
          <td class="align-center">{{ flock?.name }}</td>
          <td class="align-center">{{ flock?.arrival?.breed.name }}</td>
          <td class="align-center">{{ flock?.arrival?.amountOfHens }}</td>
          <td class="align-center">
            {{ getEggMarketingStandard(flock?.arrival?.eggMarketingStandard) }}
          </td>
          <td class="align-center">{{ flock?.arrival?.arrivalDate | agrDate: 'shortDate' }}</td>
          <td class="align-center">
            {{ flock?.departure?.departureDate | agrDate: 'shortDate' }}
          </td>
          <td class="align-center">
            {{ 141 + flock?.arrival?.deviationOfBirthDateInDays }}
            {{ 'report.flock-details.days' | translate }}
          </td>
          <td class="align-center">{{ flock?.arrival?.barn?.name }}</td>
        </tr>
      </table>
    </div>

    <div class="wrapper--spacing-horizontal wrapper--spacing-vertical table--padding-top">
      <span class="text--bold">{{ 'report.week-details.header' | translate }}</span>
      <table class="registrations-table">
        <thead>
          <tr>
            <th>{{ 'report.week-details.week' | translate }}</th>
            <th style="width: 100px">{{ 'report.week-details.weekStart' | translate }}</th>
            <th>{{ 'report.week-details.MortalityRate' | translate }}</th>
            <th>{{ 'report.week-details.MortalityRateCumulative' | translate }}</th>
            <th>{{ 'report.week-details.RateOfLay' | translate }}</th>
            <th>{{ 'report.week-details.AverageEggWeight' | translate }}</th>
            <th>{{ 'report.week-details.AverageEggWeightPerLayerPerDay' | translate }}</th>
            <th>
              {{ 'report.week-details.EggCountPerLayerInProductionCumulative' | translate }}
            </th>
            <th>
              {{ 'report.week-details.TotalEggWeightPerLayerInProductionCumulative' | translate }}
            </th>
            <th>{{ 'report.week-details.FeedConsumptionPerLayerPerDay' | translate }}</th>
            <th>
              {{ 'report.week-details.FeedConsumptionPerLayerInProduction' | translate }}
            </th>
            <th>{{ 'report.week-details.WaterToFeedRatio' | translate }}</th>
            <th>{{ 'report.week-details.FeedToEggRatio' | translate }}</th>
            <th>{{ 'report.week-details.FeedConversionRate' | translate }}</th>
            <th>{{ 'report.week-details.FeedConversionRateCumulative' | translate }}</th>
            <th>{{ 'report.week-details.AverageLayerWeight' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let kpi of KPIweeks"
            [ngClass]="{ pre21weeks: kpi.week < 21, tableSeparator: kpi.week === 21 }"
          >
            <ng-container *ngIf="isPrintableWeek(kpi.week)">
              <td>{{ kpi.week }}</td>
              <td>{{ kpi.weekStart | agrDate: 'shortDate' }}</td>
              <td class="align-right">{{ getUIValue(kpi.MortalityRate) }}</td>
              <td class="align-right">{{ getUIValue(kpi.MortalityRateCumulative) }}</td>
              <td class="align-right">{{ getUIValue(kpi.RateOfLay) }}</td>
              <td class="align-right">{{ getUIValue(kpi.AverageEggWeight) }}</td>
              <td class="align-right">{{ getUIValue(kpi.AverageEggWeightPerLayerPerDay) }}</td>
              <td class="align-right">
                {{ getUIValue(kpi.EggCountPerLayerInProductionCumulative) }}
              </td>
              <td class="align-right">
                {{ getUIValue(kpi.TotalEggWeightPerLayerInProductionCumulative) }}
              </td>
              <td class="align-right">{{ getUIValue(kpi.FeedConsumptionPerLayerPerDay) }}</td>
              <td class="align-right">{{ getUIValue(kpi.FeedConsumptionPerLayerInProduction) }}</td>
              <td class="align-right">{{ getUIValue(kpi.WaterToFeedRatio) }}</td>
              <td class="align-right">{{ getUIValue(kpi.FeedToEggRatio) }}</td>
              <td class="align-right">{{ getUIValue(kpi.FeedConversionRate) }}</td>
              <td class="align-right">{{ getUIValue(kpi.FeedConversionRateCumulative) }}</td>
              <td class="align-right">{{ getUIValue(kpi.AverageLayerWeight) }}</td>
            </ng-container>
          </tr>
        </tbody>
        <tfoot>
          <tr class="tableSeparator">
            <td>{{ 'report.week-details.cumulative' | translate }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td class="align-right">{{ getUIValue(averages?.RateOfLay) }}</td>
            <td class="align-right">{{ getUIValue(averages?.AverageEggWeight) }}</td>
            <td class="align-right">{{ getUIValue(averages?.AverageEggWeightPerLayerPerDay) }}</td>
            <td></td>
            <td></td>
            <td class="align-right">{{ getUIValue(averages?.FeedConsumptionPerLayerPerDay) }}</td>
            <td class="align-right">
              {{ getUIValue(averages?.FeedConsumptionPerLayerInProduction) }}
            </td>
            <td class="align-right">{{ getUIValue(averages?.WaterToFeedRatio) }}</td>
            <td class="align-right">{{ getUIValue(averages?.FeedToEggRatio) }}</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </agr-print-page>
</agr-page-detail>
